// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-notes-container {
  padding: 0rem !important;
  min-height: auto;
}
.modal-notes-container .modal-notes-form-wrapper {
  width: 100% !important;
}

.notes-container {
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .notes-container {
    padding: 1rem;
  }
}
.notes-container .note-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.notes-container .note-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.notes-container .note-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.notes-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: notes-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .notes-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.notes-form-wrapper .notes-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .notes-form-wrapper .notes-title {
    font-size: 1.25rem;
  }
}
.notes-form-wrapper .modal-notes-title {
  font-size: 1.3rem;
}
.notes-form-wrapper .notes-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}

.notes-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .notes-form {
    gap: 1rem;
  }
}
.notes-form .form-section:last-of-type {
  margin-bottom: 0;
}
.notes-form .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.notes-form .notes-form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
}
.notes-form .notes-form-group:last-child {
  margin-bottom: 0;
}
.notes-form .notes-form-group .notes-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.notes-form .notes-form-group .notes-label .notes-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.notes-form .notes-form-group .notes-input,
.notes-form .notes-form-group .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.notes-form .notes-form-group .notes-input:focus,
.notes-form .notes-form-group .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.notes-form .notes-form-group .notes-input::placeholder,
.notes-form .notes-form-group .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.notes-form .notes-form-group .notes-input:disabled,
.notes-form .notes-form-group .custom-dropdown-input:disabled {
  background-color: #e9ecef;
  color: #6b7280;
  cursor: not-allowed;
}
.notes-form .notes-form-group select.notes-input {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.notes-form .notes-form-group .notes-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 200px;
  resize: vertical;
}
.notes-form .notes-form-group .notes-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.notes-form .notes-form-group .notes-textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.notes-form .notes-form-group .notes-textarea::placeholder {
  color: #9ca3af;
}
.notes-form .notes-form-group .notes-textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.notes-form .notes-form-group .case-selector {
  position: relative;
}
.notes-form .notes-form-group .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .loading-state,
.notes-form .notes-form-group .case-selector .dropdown-content .no-results,
.notes-form .notes-form-group .case-selector .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.notes-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .notes-actions {
    flex-direction: column;
  }
}
.notes-actions .notes-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .notes-actions .notes-btn {
    width: 100%;
  }
}
.notes-actions .notes-btn.notes-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.notes-actions .notes-btn.notes-btn-save:focus {
  outline: none;
}
.notes-actions .notes-btn.notes-btn-save:hover {
  background-color: #005a9a;
}
.notes-actions .notes-btn.notes-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.notes-actions .notes-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.notes-actions .notes-btn-cancel:hover {
  background-color: #f8f9fa;
}

@keyframes notes-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .notes-form {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .notes-container {
    padding: 0.5rem;
  }
  .notes-form-wrapper {
    padding: 0.75rem;
  }
  .notes-title {
    font-size: 1.125rem;
  }
  .notes-form-group .notes-input,
  .notes-form-group .notes-textarea,
  .notes-form-group .custom-dropdown-input {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .notes-actions .notes-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .notes-container {
    background: white;
    padding: 0;
  }
  .notes-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .notes-actions,
  .dropdown-content {
    display: none;
  }
  .note-form-close-button {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/NoteForm/NoteForm.scss"],"names":[],"mappings":"AACA;EACE,wBAAA;EACA,gBAAA;AAAF;AAGE;EACE,sBAAA;AADJ;;AAMA;EACE,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAME;EAVF;IAWI,aAAA;EAHF;AACF;AAOE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAQI;EACE,yBAAA;EACA,cAAA;AANN;AAUI;EACE,aAAA;EACA,6CAAA;AARN;;AAeA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,2CAAA;EACA,UAAA;AAZF;AAeE;EAVF;IAWI,aAAA;IACA,WAAA;EAZF;AACF;AAgBE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAdJ;AAiBI;EARF;IASI,kBAAA;EAdJ;AACF;AAkBE;EACE,iBAAA;AAhBJ;AAqBE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAnBJ;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAtBF;AAyBE;EANF;IAOI,SAAA;EAtBF;AACF;AA8BI;EACE,gBAAA;AA5BN;AAgCI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AA9BN;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAlCJ;AAqCI;EACE,gBAAA;AAnCN;AAwCI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAtCN;AAyCM;EACE,cAAA;EACA,oBAAA;AAvCR;AA6CI;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA3CN;AA8CM;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3CR;AAoDM;;EACE,cAAA;AAjDR;AAqDM;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAlDR;AAwDI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAtDN;AA2DI;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAzDN;AA4DM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA1DR;AA8DM;EACE,qBAAA;AA5DR;AAgEM;EACE,cAAA;AA9DR;AAkEM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAhER;AAsEI;EACE,kBAAA;AApEN;AAwEM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAvER;AA0EQ;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAxEV;AA2EU;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAzEZ;AA4EY;EACE,mBAAA;EACA,cAAA;AA1Ed;AA8EY;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AA5Ed;AAkFQ;EACE,iBAAA;EACA,gBAAA;AAhFV;AAmFU;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAjFZ;AAoFY;EACE,mBAAA;AAlFd;AAsFY;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AApFd;AAuFc;EACE,gBAAA;AArFhB;AA2Fc;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAzFhB;AA6Fc;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AA5FhB;AAgGc;EACE,kBAAA;EACA,cAAA;AA9FhB;AAoGU;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAlGZ;AAwGM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAtGR;AA0GM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAxGR;AA2GQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAzGV;;AAmHA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAhHF;AAmHE;EARF;IASI,sBAAA;EAhHF;AACF;AAmHE;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjHJ;AAoHI;EAXF;IAYI,WAAA;EAjHJ;AACF;AAoHI;EACE,sCAAA;EACA,YAAA;AAlHN;AAqHM;EACE,aAAA;AAnHR;AAqHM;EACE,yBAAA;AAnHR;AAuHM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AArHR;AA0HE;EACI,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAxHN;AA2HM;EACE,yBAAA;AAzHR;;AAkIA;EACE;IACE,UAAA;IACA,2BAAA;EA/HF;EAmIA;IACE,UAAA;IACA,wBAAA;EAjIF;AACF;AAqIA;EACE;IACE,UAAA;IACA,2BAAA;EAnIF;EAuIA;IACE,UAAA;IACA,wBAAA;EArIF;AACF;AA0IA;EACE,UAAA;AAxIF;;AA4IA;EACE,mBAAA;EACA,kBAAA;AAzIF;;AA6IA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AA1IF;;AA8IA;EACE,mBAAA;AA3IF;;AAgJA;EACE;IACE,WAAA;EA7IF;AACF;AAiJA;EACE;IACE,eAAA;EA/IF;EAmJA;IACE,gBAAA;EAjJF;EAqJA;IACE,mBAAA;EAnJF;EAwJE;;;IAGE,iBAAA;IACA,oBAAA;EAtJJ;EA4JE;IACE,oBAAA;IACA,oBAAA;EA1JJ;AACF;AAgKA;EACE;IACE,iBAAA;IACA,UAAA;EA9JF;EAkKA;IACE,gBAAA;IACA,sBAAA;EAhKF;EAoKA;;IAEE,aAAA;EAlKF;EAsKA;IACE,aAAA;EApKF;AACF","sourcesContent":["// Main Container - Match ExpenseForm\n.modal-notes-container {\n  padding: 0rem !important;\n  min-height: auto;\n\n\n  .modal-notes-form-wrapper {\n    width: 100% !important;\n  }\n}\n\n\n.notes-container {\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n\n  // Close button for modal\n  .note-form-close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    z-index: 1001;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #374151;\n    }\n\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n\n\n// Form Wrapper - Match ExpenseForm wrapper structure\n.notes-form-wrapper {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  animation: notes-form-fade-in 0.3s ease-out;\n  width: 70%;\n\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    width: 100%;\n  }\n\n\n  // Title styling\n  .notes-title {\n    font-size: 1.3rem;\n    font-weight: 500;\n    color: #374151;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n\n    @media (max-width: 768px) {\n      font-size: 1.25rem;\n    }\n  }\n\n\n  .modal-notes-title {\n    font-size: 1.3rem;\n  }\n\n\n  // Divider styling\n  .notes-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n}\n\n\n// Form Content\n.notes-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n\n  @media (max-width: 768px) {\n    gap: 1rem;\n  }\n\n\n  // Form sections - Match ExpenseForm structure\n  .form-section {\n    // margin-bottom: 1.5rem;\n\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n    }\n  }\n\n\n  // Form Groups\n  .notes-form-group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0.5rem;\n\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n\n    // Label styling\n    .notes-label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n\n\n      .notes-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n\n    // Input styling to match ExpenseForm\n    .notes-input,\n    .custom-dropdown-input {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151;\n      background: #ffffff;\n      box-sizing: border-box;\n      height: 2.5rem;\n\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n\n      // &:hover:not(:focus) {\n      //   border-color: #9ca3af;\n      // }\n\n\n      &::placeholder {\n        color: #9ca3af;\n      }\n\n\n      &:disabled {\n        background-color: #e9ecef;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n\n    // Select styling\n    select.notes-input {\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1.5rem 1.5rem;\n      padding-right: 2.5rem;\n    }\n\n\n    // Textarea styling\n    .notes-textarea {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151;\n      background: #ffffff;\n      box-sizing: border-box;\n      min-height: 200px;\n      resize: vertical;\n\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n\n      &:hover:not(:focus) {\n        border-color: #9ca3af;\n      }\n\n\n      &::placeholder {\n        color: #9ca3af;\n      }\n\n\n      &:disabled {\n        background-color: #f9fafb;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n\n    // Case Selector - Match ExpenseForm exactly\n    .case-selector {\n      position: relative;\n\n\n      // Dropdown content\n      .dropdown-content {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: 100%;\n        background: #ffffff;\n        border: 1px solid #d1d5db;\n        border-radius: 0.375rem;\n        z-index: 1000;\n        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n          0 10px 10px -5px rgba(0, 0, 0, 0.04);\n        margin-top: 0.25rem;\n        overflow: hidden;\n        animation: dropdown-fade-in 0.2s ease-out;\n\n\n        .dropdown-tabs {\n          display: flex;\n          background: #f9fafb;\n          border-bottom: 1px solid #e5e7eb;\n\n\n          button {\n            flex: 1;\n            padding: 0.75rem 1rem;\n            border: none;\n            background: transparent;\n            color: #6b7280;\n            font-weight: 500;\n            font-size: 0.875rem;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            border-bottom: 2px solid transparent;\n\n\n            &:hover {\n              background: #f3f4f6;\n              color: #374151;\n            }\n\n\n            &.active {\n              background: #ffffff;\n              color: #3b82f6;\n              font-weight: 600;\n              border-bottom-color: #3b82f6;\n            }\n          }\n        }\n\n\n        .dropdown-options {\n          max-height: 250px;\n          overflow-y: auto;\n\n\n          .dropdown-option {\n            padding: 0.75rem 1rem;\n            cursor: pointer;\n            border-bottom: 1px solid #f3f4f6;\n            transition: all 0.2s ease;\n\n\n            &:hover {\n              background: #f9fafb;\n            }\n\n\n            &.selected {\n              background: #eff6ff;\n              color: #1e40af;\n              border-left: 3px solid #3b82f6;\n\n\n              .case-parties {\n                font-weight: 600;\n              }\n            }\n\n\n            .case-info {\n              .case-parties {\n                font-weight: 500;\n                color: #374151;\n                font-size: 0.875rem;\n                margin-bottom: 0.25rem;\n                line-height: 1.4;\n              }\n\n\n              .case-ref {\n                font-size: 0.75rem;\n                color: #6b7280;\n                font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\n                  \"Liberation Mono\", Menlo, monospace;\n                background: #f3f4f6;\n                padding: 0.125rem 0.375rem;\n                border-radius: 0.25rem;\n                display: inline-block;\n                margin-bottom: 0.25rem;\n              }\n\n\n              .case-number {\n                font-size: 0.75rem;\n                color: #9ca3af;\n              }\n            }\n          }\n\n\n          .no-data {\n            padding: 2rem 1rem;\n            text-align: center;\n            color: #6b7280;\n            font-style: italic;\n            font-size: 0.875rem;\n          }\n        }\n\n\n       \n      .loading-state,\n      .no-results,\n      .empty-state {\n        padding: 2rem 1rem;\n        text-align: center;\n        color: #6b7280;\n        font-style: italic;\n        font-size: 0.875rem;\n      }\n\n\n      .loading-state {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n\n\n        &::before {\n          content: '';\n          width: 16px;\n          height: 16px;\n          border: 2px solid #e5e7eb;\n          border-top: 2px solid #3b82f6;\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n        }\n      }\n      }\n    }\n  }\n}\n\n\n// Form Actions - Match ExpenseForm\n.notes-actions {\n  display: flex;\n  justify-content: end;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n\n  .notes-btn {\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: 0.375rem;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    min-width: 120px;\n    transition: all 0.2s ease;\n\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n\n\n    &.notes-btn-save {\n      background-color: var(--primary-color);\n      color: white;\n\n\n      &:focus {\n        outline: none;\n      }\n      &:hover{\n        background-color: #005a9a;\n      }\n\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n    }\n   \n  }\n  .notes-btn-cancel {\n      padding: 8px 16px;\n      border: 1px solid #ddd;\n      background: white;\n      color: #666;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 14px;\n\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n    }\n\n\n}\n\n\n// Animations\n@keyframes notes-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n// Scrollbar styling for dropdown\n.dropdown-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n\n.dropdown-options::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n\n.dropdown-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n\n.dropdown-options::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .notes-form {\n    width: 100%;\n  }\n}\n\n\n@media (max-width: 480px) {\n  .notes-container {\n    padding: 0.5rem;\n  }\n\n\n  .notes-form-wrapper {\n    padding: 0.75rem;\n  }\n\n\n  .notes-title {\n    font-size: 1.125rem;\n  }\n\n\n  .notes-form-group {\n    .notes-input,\n    .notes-textarea,\n    .custom-dropdown-input {\n      padding: 0.375rem;\n      font-size: 0.8125rem;\n    }\n  }\n\n\n  .notes-actions {\n    .notes-btn {\n      padding: 0.5rem 1rem;\n      font-size: 0.8125rem;\n    }\n  }\n}\n\n\n// Print styles\n@media print {\n  .notes-container {\n    background: white;\n    padding: 0;\n  }\n\n\n  .notes-form-wrapper {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n\n\n  .notes-actions,\n  .dropdown-content {\n    display: none;\n  }\n\n\n  .note-form-close-button {\n    display: none;\n  }\n}\n\n\n// Focus visible improvements for accessibility\n// input:focus-visible,\n// select:focus-visible,\n// button:focus-visible,\n// textarea:focus-visible {\n//   outline: 2px solid #3b82f6;\n//   outline-offset: 2px;\n// }\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
